// Stripe hosted page URLs (LIVE MODE)
export const STRIPE_CUSTOMER_PORTAL_URL = 'https://billing.stripe.com/p/login/6oUdR9alvdgl08eauxbfO00'

// Price IDs (LIVE MODE)
export const STRIPE_PRICES = {
  sports_weekly:       'price_1SAlfTGUT1EaVDa9FlJWDVhD',
  sports_monthly:      'price_1SAlfTGUT1EaVDa9oaqKH1px',
  horse_racing_weekly: 'price_1SAliAGUT1EaVDa9apMaaN5G',
  horse_racing_monthly:'price_1SAliAGUT1EaVDa9hUOWwfJ6',
  full_access_weekly:  'price_1SAljFGUT1EaVDa9YXAf2ccQ',
  full_access_monthly: 'price_1SAljFGUT1EaVDa9KmYujtPO',
}

// Create pricing page URL (opens in new tab)
export const getPricingPageUrl = () => {
  // We'll create a simple page that embeds the Stripe pricing table
  return `${window.location.origin}/#/pricing`
}

// Navigate to customer portal
export const goToCustomerPortal = () => {
  window.open(STRIPE_CUSTOMER_PORTAL_URL, '_blank')
}

// Navigate to pricing page  
export const goToPricingPage = () => {
  window.open(getPricingPageUrl(), '_blank')
}